export const UPDATE_VIDEO = "UPDATE_VIDEO";
export const SUBMIT_FORM = "SUBMIT_FORM";
export const DOWNLOAD_ASSET = "DOWNLOAD_ASSET";
